// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.
import { client } from "./generated/client.gen";
import type { ErrorModel } from "./generated";
import { authenticatedFetch } from "../auth";
export { apiBaseUrl } from "./config";
import { apiBaseUrl } from "./config";

client.setConfig({
  baseUrl: apiBaseUrl,
  credentials: "include",
  fetch: authenticatedFetch,
  headers: {
    Accept: "application/json",
    "X-Nadrama-CSRF": "1",
  },
  responseStyle: "data",
  throwOnError: true,
});

export const authSlotHeaders = (slot: number) => ({
  "X-Nadrama-Auth-Slot": slot,
});

// Redirect endpoints must be navigated to directly: fetch follows their redirects invisibly.
export const apiUrl = (path: string): string =>
  new URL(path, apiBaseUrl).toString();

export const apiErrorMessage = (error: unknown): string => {
  const model = error as ErrorModel | undefined;
  if (model?.status === 502 || model?.status === 503 || model?.status === 504) {
    return "Nadrama is temporarily unavailable. Please try again shortly.";
  }
  if (model?.status !== undefined && model.status >= 500) {
    return "Something went wrong on our side. Please try again shortly.";
  }
  if (
    error instanceof TypeError &&
    /failed to fetch|load failed|networkerror/i.test(error.message)
  ) {
    return "Nadrama is temporarily unavailable. Check your connection and try again.";
  }
  if (error instanceof Error) return error.message;
  return model?.detail ?? model?.title ?? "The request could not be completed.";
};
